/**
 * Предел одного файла в загрузке комплекта.
 *
 * Комплект уходит пачками (`uploadBatches.ts`), так что общий размер отправку
 * не ограничивает. А вот отдельный файл тяжелее потолка не влезет ни в какую
 * пачку — дробить один файл мы не умеем, и упрётся он только после долгой
 * заливки, поэтому форма предупреждает заранее.
 */
import { MAX_UPLOAD_BYTES } from './formatFile';

/** Файл крупнее потолка не влезет ни в какую пачку — бэкенд ответит 413. */
export const isTooLargeAlone = (file: File): boolean => file.size > MAX_UPLOAD_BYTES;
